export enum StatusEffectGroup {
  BUFF = "BUFF",
  DEBUFF = "DEBUFF",
  WALL = "WALL",
}
